function QuizTitle({children, color=""}){
    return <h2 className="quizTitle" style={{color}}>{children}</h2>
}

export default QuizTitle;